import {nodeType} from '../constants/NodeTypes';
import GeneratorEntity from './Generator';

class Node {
  public children: GeneratorEntity[]
  public displayName: string
  public propertyName: string;
  public nodeType: nodeType;

  public constructor() {
    this.children = [];
    this.displayName =  'Home';
    this.propertyName = "";
    this.nodeType = nodeType.folder
  }
}


export default Node;



// WEBPACK FOOTER //
// ./src/models/Node.ts